import React, { useState, useEffect } from "react";
import "./companyLevelPdf.css";
import { FetchedCompanyLogoContext } from "../../fetchedCompanyLogo";
import { useContext } from "react";
import { CompanyLevelAttendanceContext } from "../../companyLevelAttendanceContext";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import constants from "../../../utils/constants";
import { TimeDifferenceCalculator } from "../../../utils/commonFunction/timeConvertor";
import api from "../../../services/api";
import strings from "../../../utils/property-file/companyPdf.json"

function CompanyLevelPdf() {
  const nav = useNavigate();
  const companyName = localStorage.getItem(strings.companyInfoLabel);
  const exportReportDate = localStorage.getItem(strings.localStorageExportReportLabel);
  const selectedDate = localStorage.getItem(strings.selectedDate);
  const { companyLogo } = useContext(FetchedCompanyLogoContext);
  const [base64String, setBase64String] = useState(null);
  const firebaseImageString = companyLogo;
  const { attendanceData, setAttendanceData } = useContext(
    CompanyLevelAttendanceContext
  );
  
  const generatedTime = (new Date()).toString();
  function createPDF() {
    window.print();
    window.onafterprint = function() {
      localStorage.removeItem(strings.localStorageExportReportLabel);
      localStorage.removeItem(strings.selectedDate);
      nav(constants.navigationLink.dashboardLink);
      toast.success(strings.reportExportedLabel, { toastId: "error6" });
  };
  }

  useEffect(() => {
    if (firebaseImageString) {
      fetchImageAndConvertToBase64(firebaseImageString);
    }
  }, [firebaseImageString]);

  const fetchImageAndConvertToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onload = function (e) {
        const base64String = e.target.result;
        setBase64String(base64String);
      };
      reader.readAsDataURL(blob);
    } catch (error) {return;}
  };

  if (!localStorage.getItem(strings.localStorageExportReportLabel)) {
    nav(constants.navigationLink.dashboardLink);
  }

  const generateReport = async () => {
    try {
      const response = await api.getCompanyAttendanceData(exportReportDate);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if(response.success){
          setAttendanceData(data);
        }
      else{
        setAttendanceData([]);
      }
      }
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel ,{toastId : "error6"})
    }
  };

  function handleExportClick() {
    createPDF();
   
  }

  function handleCancelClick() { 
    localStorage.removeItem(strings.localStorageExportReportLabel);
    localStorage.removeItem(strings.selectedDate);
    nav(constants.navigationLink.dashboardLink);
  }

  useEffect(() => {
    generateReport();
  }, []);

  return (
    <div className="main-container-format">
      <div className="pdf-download-button-company-level">
        <button
          onClick={() => {
            handleExportClick();
          }}
        >
          <span className="download-company-pdf-btn"><i className="ri-download-line"></i><span>{strings.downloadLabel}</span></span>
        </button>
        <button
          onClick={() => {
            handleCancelClick();
          }}
          className="me-3"
        >
          <span className="download-company-pdf-btn"><span>{strings.cancelLabel}</span></span>
        </button>
      </div>
      <div id="pdf-content" className="main-container-pdf-company">
        <div className="company-details">
          {base64String ? (
            <img src={base64String} alt="" className="company-export-logo" />
          ) : null}

          <h1 className="name-file">{companyName}</h1>
        </div>
        <div className="sub-container-pdf-company">
          <div className="company-name">{strings.reportType}</div>
          <div className="company-name">
           {strings.dateLabel}: {selectedDate}
          </div>
        </div>
        <div className="generated-time">{strings.generatedPdf} {generatedTime!=null ? moment(generatedTime).format("DD/MM/YYYY HH:mm") : null}</div>
        <div className=" mt-3 mx-auto ">
          <table className="company-report-table">
            <thead className="company-level-export-thead">
              <tr>
                <th scope="col">{strings.employeeId}</th>
                <th scope="col">{strings.empName}</th>
                <th scope="col">{strings.checkIn}</th>
                <th scope="col">{strings.checkOut}</th>
                <th scope="col">{strings.duration}</th>
                <th scope="col">{strings.status}</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData !== null && attendanceData.body && attendanceData.body.length>0
                ? attendanceData.body.map((item, index) => (
                    <tr key={index} >
                      <td>{item.empId}</td>
                      <td>{item.name}</td>
                      <td>
                        {item.SignIn !== strings.naLabel
                          ? moment(item.SignIn).format(strings.timeFormatLabel)
                          : strings.naLabel}
                      </td>
                      <td>
                        {item.SignOut !== strings.naLabel
                          ? moment(item.SignOut).format(strings.timeFormatLabel)
                          : strings.naLabel}
                      </td>
                      <td>
                        {item.SignIn !== strings.naLabel && item.SignOut !== strings.naLabel ? (
                          <TimeDifferenceCalculator
                            time1={moment(item.SignIn).format(strings.timeFormatLabel)}
                            time2={moment(item.SignOut).format(strings.timeFormatLabel)}
                          />
                        ) : (
                          strings.naLabel
                        )}
                      </td>
                      <td>{item.Status}</td>
                    </tr>
                  ))
                : <td className="text-center" colSpan={6}>{strings.dataNotAvailable}</td>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CompanyLevelPdf;
